import { Link } from "react-router-dom";

const mainCities = [
  { name: "Madrid", slug: "madrid" },
  { name: "Barcelona", slug: "barcelona" },
  { name: "Valencia", slug: "valencia" },
  { name: "Sevilla", slug: "sevilla" },
  { name: "Málaga", slug: "malaga" },
  { name: "Bilbao", slug: "bilbao" },
  { name: "Zaragoza", slug: "zaragoza" },
  { name: "Murcia", slug: "murcia" },
  { name: "Alicante", slug: "alicante" },
  { name: "Granada", slug: "granada" },
];

export const FooterCities = () => {
  return (
    <div>
      <h4 className="font-semibold mb-4">Ciudades Principales</h4>
      <ul className="space-y-2 text-sm">
        {mainCities.map((city) => (
          <li key={city.slug}>
            <Link
              to={`/ciudad/${city.slug}`}
              className="text-muted-foreground hover:text-primary transition-colors"
            >
              {city.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
